import { combineReducers } from 'redux';

import { aggregate } from './aggregate';
import { annotations } from './annotations';
import { discovery } from './discovery';
import { locations } from './locations';
import { playlists } from './playlists';
import { sources } from './sources';
import { timeline } from './timeline';
import { topCities } from './topCities';

export const song = combineReducers({
  locations,
  aggregate,
  annotations,
  sources,
  discovery,
  timeline,
  topCities,
  playlists,
});
